import React from 'react';
import { useTranslation } from 'react-i18next';

type Feature = {
  id: number;
  title: string;
  description: string;
  img: string;
};

interface AuthSupportiveInfoSectionProps {
  features: Feature[];
}

const AuthSupportiveInfoSection = ({
  features,
}: AuthSupportiveInfoSectionProps) => {
  const { t } = useTranslation(['auth']);

  return (
    <div
      className="t-flex t-flex-col t-items-center lg:t-flex-row lg:t-justify-between"
      data-testid="AuthSupportiveInfoSection"
    >
      {features.map((feature) => (
        <div
          className={`t-flex t-flex-col t-items-center t-max-w-80 md:t-max-w-64 t-mt-7 lg:t-mt-0 ${
            feature.id !== 1 ? 'xl:t-ml-24 lg:t-ml-14' : ''
          }`}
          key={feature.id}
        >
          <img
            src={feature.img}
            className="t-max-h-20"
            alt={t(feature.title)}
          />
          <h2 className="typo-beta t-mt-3">{t(feature.title)}</h2>
          <p className="typo-epsilon t-text-beta-500 t-text-center t-mt-2.5">
            {t(feature.description)}
          </p>
        </div>
      ))}
    </div>
  );
};

export default AuthSupportiveInfoSection;
